import axios from "axios";

const api = axios.create({
    baseURL: "https://go.noddok.com/",
});

export default api;
